/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LogoutUserDataParser = /* #__PURE__ */ parsers.object([
    ['token', codecString],
]);
export class LogoutUserData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LogoutUserDataParser.decode(input).map(res => new LogoutUserData(res));
    }
    static unsafeDecode(input) {
        return LogoutUserData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LogoutUserDataParser.encode(data);
    }
    static schema() {
        return LogoutUserDataParser.schema();
    }
}
